import React, { useState } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Label,
  Input,
  Collapse,
} from 'reactstrap';

// Reused as-is: this table already renders exactly the columns the DOD asks for
// (Type / OT / Volume / DDR / DDR Notes / Incoterms / Incoterms Notes / Tujuan,
// expanding to Crude/Condensat with Max Capacity, Remark, Is Via CIB Only and
// both % Bleeding columns). TenderOpening is a sibling module under PlanAndProcurement.
import CargoTable from '../../TenderOpening/components/CargoTable';
import { formatMonth, formatDateTime } from '../../formatters';

// Invitation - External > Invitation tab — VIEW ONLY.
//
// Everything shown here was captured by the buyer during Planning; the DMUT reads
// it to decide whether to Accept or Decline. Sections, in the DOD's order:
// Contract, Cargo Specification, Clause Detail, Other Clause, Validity.
const InvitationTab = ({ detail }) => {
  const req = detail?.requirement || {};
  const validity = req.validity || {};
  const [openClauses, setOpenClauses] = useState({});

  return (
    <div>
      <div className='mb-3'>
        <h5 className='mb-1'>
          <i className='ri-mail-open-line me-2'></i>
          Invitation Information
        </h5>
        <p className='text-muted mb-0 fs-12'>
          Requirement issued by Pertamina for this tender (view only).
        </p>
      </div>

      <Card className='border shadow-sm'>
        <CardBody>
          {/* ---- Contract ---- */}
          <p className='form-label mb-1 fs-13 text-uppercase fw-semibold'>
            Contract
          </p>
          <Row className='g-3'>
            <Col lg={4} sm={6}>
              <Label className='form-label'>Contract Type</Label>
              <Input value={req.contractType || '-'} readOnly disabled />
            </Col>
            <Col lg={4} sm={6}>
              <Label className='form-label'>Start Period</Label>
              <Input
                value={formatMonth(req.startPeriod) || '-'}
                readOnly
                disabled
              />
            </Col>
            <Col lg={4} sm={6}>
              <Label className='form-label'>End Period</Label>
              <Input
                value={formatMonth(req.endPeriod) || '-'}
                readOnly
                disabled
              />
            </Col>
          </Row>

          {/* ---- Cargo Specification ---- */}
          <div className='mt-4 pt-3 border-top'>
            <p className='form-label mb-1 fs-13 text-uppercase fw-semibold'>
              Cargo Specification
            </p>
            <CargoTable cargos={req.cargos} variant='requirement' />
          </div>

          {/* ---- Clause Detail ---- */}
          <div className='mt-4 pt-3 border-top'>
            <p className='form-label mb-2 fs-13 text-uppercase fw-semibold'>
              Clause Detail
            </p>
            {(req.clauses || []).length === 0 ? (
              <p className='text-muted fs-12 mb-0'>No clause data</p>
            ) : (
              (req.clauses || []).map(c => {
                const open = !!openClauses[c.clauseId];
                return (
                  <Card className='border mb-2' key={c.clauseId}>
                    <CardHeader
                      role='button'
                      className='d-flex align-items-center justify-content-between py-2'
                      onClick={() =>
                        setOpenClauses(prev => ({
                          ...prev,
                          [c.clauseId]: !open,
                        }))
                      }
                    >
                      <span className='fw-semibold'>{c.title}</span>
                      <i
                        className={`ri-arrow-${open ? 'up' : 'down'}-s-line fs-18`}
                      ></i>
                    </CardHeader>
                    <Collapse isOpen={open}>
                      <CardBody>
                        <div className='form-check form-switch mb-3'>
                          <Input
                            type='checkbox'
                            role='switch'
                            className='form-check-input'
                            checked={!!c.mandatory}
                            disabled
                          />
                          <Label className='form-check-label'>
                            Mandatory clause for DMUT to fulfill
                          </Label>
                        </div>
                        <Label className='form-label'>Summary Note</Label>
                        <Input
                          type='textarea'
                          rows={4}
                          value={c.summernote || ''}
                          disabled
                        />
                      </CardBody>
                    </Collapse>
                  </Card>
                );
              })
            )}
          </div>

          {/* ---- Other Clause ---- */}
          <div className='mt-4 pt-3 border-top'>
            <p className='form-label mb-1 fs-13 text-uppercase fw-semibold'>
              Other Clause
            </p>
            <Label className='form-label'>
              Other Term and Condition, Summary Note
            </Label>
            <Input
              type='textarea'
              rows={5}
              value={req.additionalNotes || ''}
              disabled
            />
          </div>

          {/* ---- Validity ----
              Both are labelled "Jakarta Time" per the DOD, and formatDateTime now
              pins Asia/Jakarta explicitly rather than following the viewer's
              machine, so the label holds in any zone. The wire value is a real
              UTC instant (ProcurementValidityTab writes it with toISOString). */}
          <div className='mt-4 pt-3 border-top'>
            <p className='form-label mb-1 fs-13 text-uppercase fw-semibold'>
              Validity
            </p>
            <Row className='g-3'>
              <Col lg={6} sm={6}>
                <Label className='form-label'>
                  Submission Deadline (Jakarta Time)
                </Label>
                <Input
                  value={formatDateTime(validity.submissionDeadline)}
                  readOnly
                  disabled
                />
              </Col>
              <Col lg={6} sm={6}>
                <Label className='form-label'>
                  Validity Period (Jakarta Time)
                </Label>
                <Input
                  value={formatDateTime(validity.validityPeriod)}
                  readOnly
                  disabled
                />
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default InvitationTab;
